import { useTranslation } from 'react-i18next';
import Badge, { type BadgeVariant } from '@/components/base/Badge';
import type { OrderPriority, OrderStatus } from '@/types';

const STATUS_VARIANTS: Record<OrderStatus, BadgeVariant> = {
  new: 'warning',
  accepted: 'info',
  under_review: 'warning',
  in_progress: 'accent',
  ready_for_delivery: 'primary',
  completed: 'success',
  cancelled: 'danger',
};

const PRIORITY_VARIANTS: Record<OrderPriority, BadgeVariant> = {
  normal: 'neutral',
  urgent: 'danger',
};

export function StatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation();
  return <Badge variant={STATUS_VARIANTS[status]}>{t(`status.${status}`)}</Badge>;
}

export function PriorityBadge({ priority }: { priority: OrderPriority }) {
  const { t } = useTranslation();
  return (
    <Badge
      variant={PRIORITY_VARIANTS[priority]}
      icon={priority === 'urgent' ? 'ri-flashlight-fill' : undefined}
    >
      {t(`priority.${priority}`)}
    </Badge>
  );
}